import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 17031 18075"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#1c1b17;stroke-width:200.304}.fil0{fill:#1c1b17}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970247983792">
        <path
          d="M10889 1553c-19 111-10 1607 5 1634 351 40 801-55 1428 86 606 137 1307 460 1735 883l102 88c72 59 366 411 432 504 732 1033 674 1829 674 3054v4437c0 558 7 843-119 1371-86 361-272 753-455 1031l-234 322c-26 33-55 71-86 103-125 128-239 268-383 377l-203 165c-41 31-72 49-112 78-39 28-73 53-114 76-316 184-378 224-752 367-333 128-609 154-946 202-61 8-108 7-173 6-82 0-105 13-179 14-862 10-1800-1-2666-1H5817c-848 0-1606-114-2281-550-40-25-77-45-118-72-794-521-1320-1274-1549-2190-146-586-102-1508-102-2124V6977c0-806 160-1410 553-2047 69-112 222-328 315-430 462-504 887-828 1560-1079 385-145 860-231 1290-231l-1-1637-449 25c-271 4-773 115-1028 185-589 162-1282 485-1768 863-134 105-275 207-399 324-244 229-491 471-684 745-35 51-65 89-102 138-69 93-129 189-190 289-65 106-118 196-174 306-162 316-301 667-406 1016-140 468-176 920-184 1384v5985c0 676 170 1339 421 1952 118 287 324 665 513 912l207 273c352 440 773 821 1246 1135 398 265 839 474 1297 623 252 81 513 150 777 192l431 55c67 10 179 16 317 20h6464c513-4 1128-151 1590-305 65-21 112-42 175-66l338-146c59-29 103-50 163-79l302-167c268-157 538-344 767-552 164-150 330-304 480-469 135-148 261-307 377-471l278-428c316-551 518-1123 626-1752 47-275 62-548 62-874V6990c0-635-55-1093-220-1672-101-353-249-680-425-999-58-106-119-195-183-296-135-216-294-410-456-606-117-142-350-382-476-485-28-24-35-24-63-51-43-40-84-74-129-112l-489-348c-648-412-1393-707-2195-809-129-16-297-39-440-46-79-4-165 4-244 0l-722-13z"
          className="fill stroke1"
          style={{
            strokeWidth: 200.304,
          }}
        />
        <path
          d="M7344 4119c-7 58-12 210 1 265 21 81 60 130 141 194 144 113 418 185 671 185 258 0 520-75 669-186 173-130 145-251 145-460-21-27-5-2881-5-3327 0-182 43-352-126-493-322-271-1083-254-1374 1-166 147-122 305-122 492v3329z"
          className="fill stroke1"
          style={{
            strokeWidth: 200.304,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
